/* Silverline theme JS — vanilla, no dependencies */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = function (cents) {
    var f = window.SL && window.SL.moneyFormat ? window.SL.moneyFormat : 'Rs. {{amount}}';
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    var whole = parts[0].replace(/\B(?=(\d{2})+(?!\d)(?=\d{3}))|\B(?=(\d{3})(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole);
  };

  /* ---------- Drawers / overlay ---------- */
  var overlay = $('[data-overlay]');
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('is-locked');
    var f = d.querySelector('input, button, a');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('is-locked');
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); openDrawer(o.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-overlay]')) closeDrawers();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Announcement rotator ---------- */
  $$('[data-announce]').forEach(function (bar) {
    var slides = $$('.announce__slide', bar);
    if (slides.length < 2) return;
    var i = 0, timer;
    function go(n) {
      slides[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
    }
    function auto() { timer = setInterval(function () { go(i + 1); }, 4200); }
    $$('[data-announce-prev]', bar).forEach(function (b) { b.onclick = function () { clearInterval(timer); go(i - 1); auto(); }; });
    $$('[data-announce-next]', bar).forEach(function (b) { b.onclick = function () { clearInterval(timer); go(i + 1); auto(); }; });
    auto();
  });

  /* ---------- Slideshow ---------- */
  $$('[data-slideshow]').forEach(function (root) {
    var track = $('[data-slides]', root);
    if (!track) return;
    var slides = $$('.slideshow__slide', track);
    var dots = $$('[data-dot]', root);
    var i = 0, timer = null;
    var delay = parseInt(root.getAttribute('data-autoplay') || '0', 10);

    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      slides.forEach(function (s, k) { s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
    }
    function play() { if (delay > 0 && slides.length > 1) timer = setInterval(function () { go(i + 1); }, delay); }
    function stop() { clearInterval(timer); }

    $$('[data-slide-prev]', root).forEach(function (b) { b.onclick = function () { stop(); go(i - 1); play(); }; });
    $$('[data-slide-next]', root).forEach(function (b) { b.onclick = function () { stop(); go(i + 1); play(); }; });
    dots.forEach(function (d, k) { d.onclick = function () { stop(); go(k); play(); }; });

    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null; play();
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    go(0); play();
  });

  /* ---------- Carousel rails ---------- */
  $$('[data-rail-wrap]').forEach(function (wrap) {
    var rail = $('[data-rail]', wrap);
    var prev = $('[data-rail-prev]', wrap);
    var next = $('[data-rail-next]', wrap);
    if (!rail || !prev || !next) return;
    function step() {
      var first = rail.firstElementChild;
      return first ? first.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 4;
      prev.hidden = rail.scrollLeft <= 4;
      next.hidden = rail.scrollLeft >= max;
    }
    prev.onclick = function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); };
    next.onclick = function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); };
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(function (root) {
    var tabs = $$('[role="tab"]', root);
    tabs.forEach(function (tab) {
      tab.onclick = function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      };
    });
  });

  /* ---------- Footer accordions (mobile) ---------- */
  $$('[data-footer-toggle]').forEach(function (btn) {
    var body = btn.nextElementSibling;
    if (!body) return;
    function apply() {
      if (window.innerWidth >= 750) { body.style.display = 'block'; return; }
      body.style.display = btn.getAttribute('aria-expanded') === 'true' ? 'block' : 'none';
    }
    btn.setAttribute('aria-expanded', 'false');
    btn.onclick = function () {
      if (window.innerWidth >= 750) return;
      btn.setAttribute('aria-expanded', btn.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      apply();
    };
    window.addEventListener('resize', apply);
    apply();
  });

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }
  function renderCart(cart) {
    updateCartCount(cart.item_count);
    var body = $('[data-cart-body]');
    var foot = $('[data-cart-foot]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a class="btn btn--outline" href="/collections/all">Start shopping</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]{3,4}(\?.*)?$)/i, '_200x$1') : '';
      return '<div class="cart-line">' +
        '<a href="' + it.url + '"><img src="' + img + '" alt="" loading="lazy" width="74" height="88"></a>' +
        '<div><a class="cart-line__name" href="' + it.url + '">' + it.product_title + '</a>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cart-line__meta">' + it.variant_title + '</div>' : '') +
        '<div class="cart-line__meta">' + money(it.final_line_price) + '</div>' +
        '<div class="qty"><button type="button" data-cart-minus="' + it.key + '" aria-label="Decrease quantity">&minus;</button>' +
        '<input type="text" value="' + it.quantity + '" readonly aria-label="Quantity">' +
        '<button type="button" data-cart-plus="' + it.key + '" aria-label="Increase quantity">+</button></div> ' +
        '<button type="button" class="cart-line__meta" data-cart-remove="' + it.key + '" style="text-decoration:underline;margin-top:6px">Remove</button>' +
        '</div></div>';
    }).join('');
    if (foot) {
      foot.hidden = false;
      var t = $('[data-cart-total]', foot);
      if (t) t.textContent = money(cart.total_price);
    }
  }
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }
  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  document.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-cart-plus]'))) {
      var line = el.closest('.cart-line'); var q = parseInt($('input', line).value, 10) + 1;
      change(el.getAttribute('data-cart-plus'), q);
    } else if ((el = e.target.closest('[data-cart-minus]'))) {
      var line2 = el.closest('.cart-line'); var q2 = Math.max(0, parseInt($('input', line2).value, 10) - 1);
      change(el.getAttribute('data-cart-minus'), q2);
    } else if ((el = e.target.closest('[data-cart-remove]'))) {
      change(el.getAttribute('data-cart-remove'), 0);
    }
  });

  /* Add to cart (cards + PDP) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-atc-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding\u2026'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message);
        return fetchCart();
      })
      .then(function () { openDrawer('cart-drawer'); })
      .catch(function (err) { alert(err.message || 'Could not add to cart.'); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* ---------- Variant picker ---------- */
  $$('[data-variant-picker]').forEach(function (root) {
    var data = JSON.parse($('[data-variant-json]', root).textContent);
    var form = root.closest('form') || $('[data-atc-form]');
    var idInput = form ? form.querySelector('[name="id"]') : null;
    var priceEl = $('[data-pdp-price]', document);
    var btn = form ? form.querySelector('[type="submit"]') : null;

    function selected() {
      return $$('[data-opt]', root).map(function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function update() {
      var sel = selected();
      var v = data.find(function (variant) {
        return variant.options.every(function (o, i) { return o === sel[i]; });
      });
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = '<span class="price__now">' + money(v.price) + '</span>';
        if (v.compare_at_price > v.price) html += '<span class="price__was">' + money(v.compare_at_price) + '</span>';
        priceEl.innerHTML = html;
        priceEl.className = 'price pdp__price' + (v.compare_at_price > v.price ? ' price--sale' : '');
      }
      if (btn) {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }
    root.addEventListener('change', update);
  });

  /* ---------- PDP gallery thumbs ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main]', g);
    $$('[data-gallery-thumb]', g).forEach(function (t, i) {
      t.onclick = function () {
        var target = main.children[i];
        if (target) main.scrollTo({ left: target.offsetLeft - main.offsetLeft, behavior: 'smooth' });
        $$('[data-gallery-thumb]', g).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      };
    });
  });

  /* ---------- Sticky add-to-cart ---------- */
  var sticky = $('[data-sticky-atc]');
  var anchor = $('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- Predictive search ---------- */
  var sInput = $('[data-predictive-input]');
  var sResults = $('[data-predictive-results]');
  if (sInput && sResults) {
    var t;
    sInput.addEventListener('input', function () {
      clearTimeout(t);
      var q = sInput.value.trim();
      if (q.length < 2) { sResults.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var p = d.resources.results.products || [];
            var c = d.resources.results.collections || [];
            sResults.innerHTML =
              (c.length ? '<div class="search-links">' + c.map(function (x) { return '<a href="' + x.url + '">' + x.title + '</a>'; }).join('') + '</div>' : '') +
              p.map(function (x) {
                return '<a class="cart-line" href="' + x.url + '">' +
                  '<img src="' + (x.featured_image ? x.featured_image.url : '') + '" alt="" loading="lazy" width="74" height="88">' +
                  '<div><div class="cart-line__name">' + x.title + '</div><div class="cart-line__meta">' + x.price + '</div></div></a>';
              }).join('');
          });
      }, 250);
    });
  }

  fetchCart();
})();

/* ============================================================
   v1.1 additions — animations, PDP interactions
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* Scroll-in animations */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    $$('[data-anim]').forEach(function (el) { io.observe(el); });
  } else {
    $$('[data-anim]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Quantity stepper */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-qty-plus], [data-qty-minus]');
    if (!el) return;
    var input = el.parentElement.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    input.value = el.hasAttribute('data-qty-plus') ? val + 1 : Math.max(1, val - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Copy to clipboard (offer codes, share link) */
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-copy]');
    if (!el) return;
    var text = el.getAttribute('data-copy');
    var done = function () {
      var old = el.innerHTML;
      el.classList.add('is-copied');
      el.innerHTML = 'Copied';
      setTimeout(function () { el.innerHTML = old; el.classList.remove('is-copied'); }, 1600);
    };
    if (navigator.clipboard) navigator.clipboard.writeText(text).then(done);
    else {
      var t = document.createElement('textarea');
      t.value = text; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); done(); } catch (err) {}
      document.body.removeChild(t);
    }
  });

  /* Gallery index counter */
  var gMain = $('[data-gallery-main]');
  var gIndex = $('[data-gallery-index]');
  if (gMain && gIndex) {
    gMain.addEventListener('scroll', function () {
      var w = gMain.clientWidth || 1;
      gIndex.textContent = Math.round(gMain.scrollLeft / w) + 1;
    }, { passive: true });
  }

  /* Delivery date estimator */
  $$('[data-delivery]').forEach(function (box) {
    var pin = $('[data-delivery-pin]', box);
    var btn = $('[data-delivery-check]', box);
    var out = $('[data-delivery-result]', box);
    var days = parseInt(box.getAttribute('data-days') || '5', 10);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var v = (pin.value || '').trim();
      out.className = 'delivery__result';
      if (!/^\d{6}$/.test(v)) {
        out.classList.add('is-err');
        out.textContent = 'Enter a valid 6 digit pincode.';
        return;
      }
      var from = new Date(); from.setDate(from.getDate() + days);
      var to = new Date(); to.setDate(to.getDate() + days + 2);
      var fmt = function (d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
      out.classList.add('is-ok');
      out.textContent = 'Delivery expected between ' + fmt(from) + ' and ' + fmt(to) + '.';
      try { localStorage.setItem('sl_pin', v); } catch (err) {}
    });
    try {
      var saved = localStorage.getItem('sl_pin');
      if (saved && pin) { pin.value = saved; }
    } catch (err) {}
    if (pin) pin.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); btn.click(); } });
  });

  /* Add-on products: add the extra variant to the cart after the main item */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#pdp-form');
    if (!form) return;
    var extras = $$('[data-addon-variant]').filter(function (cb) {
      return cb.checked && cb.getAttribute('data-addon-variant');
    }).map(function (cb) { return { id: cb.getAttribute('data-addon-variant'), quantity: 1 }; });
    if (!extras.length) return;
    setTimeout(function () {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: extras })
      }).catch(function () {});
    }, 700);
  });

  /* Buy now: add to cart then go straight to checkout */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    e.preventDefault();
    var form = document.getElementById('pdp-form');
    if (!form) return;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Please wait\u2026';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });
})();
